<template>
  <div>
    <header class="navigation" id="navigation">
      <div class="navigation_left">
        <div class="menuIcon" id="dashboardMenu">
          <span></span>
        </div>
      </div>
      <div class="navigation_center" id="logo">
        <router-link :to="auth_prizeo === 'loggedin' ? '/home' : '/login'">
          <div class="logo">
            <img src="../../assets/prizeo/imgs/prizeo-logo.png" />
          </div>
        </router-link>
      </div>

      <div class="navigation__right">
        <div class="panelWrap">
          <Search v-if="auth_prizeo === 'loggedin'"/>
          <span class="icon flaticon-bell" id="notificationIcon"></span>
        </div>
      </div>
      <div id="notification" data-att="" class="navigation__notificationWrap">
        <Notification v-if="auth_prizeo === 'loggedin'"/>
      </div>
    </header>
    <nav class="siteNavMobile">
      <div class="siteNavMobile__wraper">
          <div>
        <div class="userAccount">
          <div class="userAccount__image">
            <router-link :to="auth_prizeo === 'loggedin' ? '/profile' : ''" class="browse_link">
              <img src="../../assets/prizeo/imgs/dummy_account.jpeg" />
              <span class="icon flaticon-pencil-edit-button"></span>
            </router-link>
          </div>
          <div class="userAccount__name">
            <p>{{$t("hello")}}</p>
          </div>
        </div>
        <ul class="navLinks">
          <li>
            <div class="translationBtns">
              <div class="btnContainer left inline">
                <button id="lang1" lang="english" class="mobiBtn sm ">
                  <img lang="english" src="https://i.imgur.com/oi8qUPx.png" />
                  <span lang="english">English</span>
                </button>
                <div v-html="langButton_prizeo" id="lang2"></div>
              </div>
            </div>
          </li>
          <div v-if="auth_prizeo === 'loggedin'">
            <li class="navLinks__item">
              <router-link to="/home" class="browse_link">{{
                $t("home")
              }}</router-link>
            </li>
            <li class="navLinks__item">
              <router-link to="/browse" class="browse_link ">{{
                $t("browse")
              }}</router-link>
              <ul class="subNavLinks">
                <li class="subNavLinks__item" v-for="cat in $props.browse.category" :key="cat.key">
                  <router-link :to="{name: 'Category', params: { category: cat.route+'-'+cat.category_id }}">
                    <span :class="cat.icon" class="icon"></span>
                    <span>{{ cat[`title_${lang_prizeo}`] }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="navLinks__item sm">
              <router-link
                style="text-decoration:none;"
                to="/hotpicks"
                class="browse_link text_color"
                ><span class="flaticon-flame icon"></span
                >{{ $t("hotpicks") }}</router-link
              >
            </li>
            <li class="navLinks__item sm">
              <router-link
                style="text-decoration:none;"
                to="/popular"
                class="browse_link text_color"
                ><span class="flaticon-graph icon"></span
                >{{ $t("popular") }}</router-link
              >
            </li>
            <!-- <li class="navLinks__item sm">
              <router-link
                style="text-decoration:none;"
                to="/popular"
                class="browse_link text_color"
                ><span class="flaticon-bookmark-star icon"></span
                >{{ $t("favorites") }}</router-link
              >
            </li> -->
            <!-- <li class="navLinks__item sm" v-if="auth === ''">
              <a
                style="text-decoration:none;"
                class="login_btn"
                href="/login"
                >{{ $t("login") }}
              </a>
            </li> -->
            <li class="navLinks__item sm" v-if="auth_prizeo === 'loggedin'">
              <!-- <a
                style="text-decoration:none;"
                class="login_btn"
                href="/logout"
                @click="logout()"
                >{{ $t("unsubscribe") }}
              </a> -->
              <div v-if="country_prizeo == 'iq'">
                <a style="text-decoration:none; color: white; text-align:center" class="mobiBtn" data-toggle="modal" data-target="#exampleModalCenter">
                  {{ $t("unsubscribe") }}
                </a>
              </div>
              <div v-else>
                <a @click="logout_prizeo(is_unsub_prizeo)" style="text-decoration:none; color: white; text-align:center" class="mobiBtn">{{ $t("unsubscribe") }}</a>
              </div>
            </li>
          </div>
        </ul>
      </div>
      <ul class="navLinks footer">
        <!-- <li class="navLinks__item xs">
          <router-link to="/contact" class="browse_link text_color"
            ><span class="flaticon-phone icon"></span
            >{{ $t("contact_us") }}</router-link
          >
        </li> -->
        <!-- <li class="navLinks__item sm">
          <router-link to="/" class="browse_link text_color"
            ><span class="flaticon-settings icon"></span
            >{{ $t("settings") }}</router-link
          >
        </li> -->
        <li class="navLinks__item xs">
          <router-link to="/privacy" class="browse_link text_color">
            <span class="flaticon-padlock icon"></span>
            <span>{{ $t("privacy") }}</span>
            </router-link>
        </li>
        <li class="navLinks__item xs">
          <router-link to="/feedback" class="browse_link text_color">
              <span class="flaticon-information-button icon"></span>
              <span>{{ $t("feedback") }}</span>
          </router-link>
        </li>
      </ul>

      </div>
      
      <div class="closeNav">
        <div class="menuIcon" id="navMobileClose">
          <span></span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import prizeo from "../../router/prizeo";
import prizeoData from "./prizeo-js/prizeo";
import Search from "../prizeo/Search.vue";
import Notification from "../prizeo/Notification.vue";
import { mapGetters, mapActions } from "vuex";
import gsap, { TimelineLite, Linear } from "gsap";
export default {
  data() {
    return {};
  },
  props: ["browse"],
  components: {
    Search,
    Notification
  },
  computed: mapGetters([
    "langButton_prizeo",
    "lang_prizeo",
    "auth_prizeo",
    "country_prizeo",
    "is_unsub_prizeo"
  ]),
  mounted() {
    this.fetchTranslateButton_prizeo(this.country_prizeo);

    const btnLang1 = document.getElementById("lang1");
    const btnLang2 = document.getElementById("lang2");

    const notificationIcon = document.getElementById("notificationIcon");
    const notificationPanel = document.getElementById("notification");

    if (this.lang_prizeo == "english") {
      if (this.country_prizeo != "ke1" && this.country_prizeo != "ke") {
        btnLang2.style.display = "block";
        btnLang1.style.display = "none";
      } else {
        btnLang2.style.display = "none";
        btnLang1.style.display = "none";
      }
    } else if (this.lang_prizeo != "english") {
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
    }

    // button translate
    btnLang1.addEventListener("click", e => {
      let lang = e.target.getAttribute("lang");
      this.$i18n.locale = "english";
      this.fetchLocale_prizeo(lang);
      localStorage.setItem("lang_prizeo", lang);
      btnLang2.style.display = "block";
      btnLang1.style.display = "none";
      document.getElementsByTagName("html")[0].classList.remove("ar_layout");
    });

    btnLang2.addEventListener("click", e => {
      let lang = e.target.getAttribute("lang");
      this.$i18n.locale = lang;
      this.fetchLocale_prizeo(lang);
      localStorage.setItem("lang_prizeo", lang);
      btnLang2.style.display = "none";
      btnLang1.style.display = "block";
      if (lang == "arabic") {
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
      } else {
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      }
    });

    //notification
    notificationIcon.addEventListener("click", e => {
      notificationPanel.classList.toggle("show");
    });
    //Body listen clicks

    document.addEventListener("click", event => {
      let isClickedInside =
        notificationPanel.contains(event.target) ||
        notificationIcon.contains(event.target);

      if (!isClickedInside) {
        notificationPanel.classList.remove("show");
      }
    });
    //init menu
    this.$nextTick(() => {
      this.intiSideMenu();
      this.initTopNavScroll();
    });
  },
  methods: {
    ...mapActions([
      "fetchLocale_prizeo",
      "fetchTranslateButton_prizeo",
      "logout_prizeo"
    ]),
    intiSideMenu() {
      // init mobile menu
      const mobileLinks = document.querySelectorAll(".browse_link");
      const menuIcons = document.querySelectorAll(".menuIcon");
      Object.keys(menuIcons).map(elm => {
        menuIcons[elm].addEventListener("click", () => {
          document.body.classList.toggle("mobile--active");
        });
      });
      Object.keys(mobileLinks).map(elm => {
        mobileLinks[elm].addEventListener("click", () => {
          document.body.classList.remove("mobile--active");
        });
      });
    },
    initTopNavScroll() {
      const navbar = document.getElementById("navigation");

      document
        .getElementsByTagName("html")[0]
        .addEventListener("wheel", hideOnScrollHeader);
      function hideOnScrollHeader() {
        let hasClass = document.body.classList.contains("mobile--active");

        if (event.wheelDeltaY < 0 && !hasClass) {
          navbar.classList.add("stick", "hide");
          document.body.classList.remove("mobile--active");
        } else {
          document;
          navbar.classList.remove("stick", "hide");
        }
      }
    },
    logout() {
      localStorage.removeItem("userToken_prizeo");
      localStorage.removeItem("logged-in");
      //router.push({name: Login}).catch(err => {})
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == "Category" && to.name == "Category") {
        location.reload();
      }
      // if(from.name == "HotPicks" && to.name == "HotPicks"){
      //   location.reload();
      // }
      // this.$router.push(`/category/game-2`)
      // react to route changes...
    }
  }
};
</script>

<style lang="css">
@import url("../../assets/prizeo/fonts/prizeo/flaticon.css");
</style>
<style lang="scss" scoped>
.subNavLinks {
  list-style: none;
  padding: 0px 0px 0px 15px;
  .subNavLinks__item {
    margin: 15px 0;
    a {
      font-size: 1.2rem !important;
      line-height: normal;
      font-weight: 500;
      text-decoration: none;
    }
    span {
      display: inline-block;
    }
    span:before {
      font-size: 24px !important;
      vertical-align: middle;
      font-weight: normal;
      margin-left: 0;
    }
  }
}
.navigation__notificationWrap {
  display: none;
  position: absolute;
  right: 15px;
  top: 54px;
}
.navigation__notificationWrap.show {
  display: block;
}
#search {
  display: none;
}

.navigation {
  height: 77px;
  padding: 0 15px;
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  background: rgba(0, 0, 0, 0.15);
  .icon::before {
    color: #fff;
    cursor: pointer;
  }
}

.navigation.stick {
  transform: translateY(-78px);
}
.logo {
  width: 120px;
  img {
    width: 100%;
  }
}
.menuIcon {
  border: 0;
  background: transparent;
  position: relative;
  width: 34px;
  height: 30px;
  cursor: pointer;
  outline: none;
  margin-left: 0;

  &:before {
    top: 5px;
  }
  &:after {
    top: 23px;
  }
  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 34px;
    height: 2px;
    background-color: #fff;
    transition-property: color, opacity, -webkit-transform;
    -webkit-transition-property: color, opacity, -webkit-transform;
    transition-property: transform, color, opacity;
    transition-property: transform, color, opacity, -webkit-transform;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
    -webkit-transform-origin: center;
    transform-origin: center;
  }
}
.menuIcon > span {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;
  text-indent: 100%;
  white-space: nowrap;
  cursor: pointer;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 34px;
    height: 2px;
    background-color: #fff;
    transition-property: color, opacity, -webkit-transform;
    -webkit-transition-property: color, opacity, -webkit-transform;
    transition-property: transform, color, opacity;
    transition-property: transform, color, opacity, -webkit-transform;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
    -webkit-transform-origin: center;
    transform-origin: center;
    top: 14px;
  }
}
.siteNavMobile {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 240px;
  background: #fff;
  transform: translateX(-240px);
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  .siteNavMobile__wraper {
    display: flex;
    flex-direction: column;
    padding: 2rem 0;
    justify-content: space-between;
    overflow-y: auto;
    width: 100%;
    height: 100%;
  }
  .closeNav {
    position: absolute;
    right: 0px;
    width: 82px;
    text-align: right;
    top: 21px;
    border-radius: 19px;
    background-color: #fff;
  }
  .menuIcon {
    margin: 0;
    display: inline-block;
    vertical-align: middle;
  }
  .menuIcon:before,
  .menuIcon:after {
    background-color: #f17521;
    height: 3px;
    width: 21px;
  }
}
.mobile--active .closeNav {
  right: -35px;
}
.navLinks {
  list-style: none;
  padding: 0 15px;
  margin: 15px 0px 0px;
  .navLinks__item {
    margin: 25px 0px;
    a {
      display: block;
      color: #000;
      font-size: 1.4rem;
    }
    .icon {
      &:before {
        color: #c05b74;
        font-size: 21px;
        padding-right: 8px;
        margin: 0;
      }
    }
  }
  .navLinks__item.sm {
    a {
      font-size: 1.2rem;
      &:hover {
        text-decoration: none;
      }
      &:before {
        font-size: 24px !important;
      }
    }
  }
  .navLinks__item.xs {
    a {
      font-size: 1rem;
      text-decoration: none;
      &:before {
        font-size: 21px !important;
      }
    }
  }
}
.navLinks.footer {
  border-top: 1px solid #000;
}
// .mobile--active .navigation {

//   width: 100%;
// }
.mobile--active .siteNavMobile {
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.mobile--active .menuIcon::before {
  color: #fff;
  -webkit-transform: translateY(9px) rotate(135deg);
  -ms-transform: translateY(9px) rotate(135deg);
  transform: translateY(9px) rotate(135deg);
}
.mobile--active .menuIcon::after {
  color: #fff;
  -webkit-transform: translateY(-9px) rotate(45deg);
  -ms-transform: translateY(-9px) rotate(45deg);
  transform: translateY(-9px) rotate(45deg);
}
.mobile--active .menuIcon > span::before {
  opacity: 0;
  -webkit-transition-duration: 0.1s;
  -o-transition-duration: 0.1s;
  transition-duration: 0.1s;
}
.userAccount {
  text-align: center;
  position: relative;
}
.userAccount__image {
  position: relative;
  width: 92px;
  height: 92px;
  margin: 0 auto;
  border-radius: 50%;
  img {
    width: 100%;
    border-radius: 50%;
  }
  .icon {
    position: absolute;
    background-color: #f17521;
    width: 28px;
    border-radius: 50%;
    height: 28px;
    line-height: 28px;
    bottom: 0;
    right: 0;
    &:before {
      margin: 0;
      color: #fff;
      font-size: 16px !important;
    }
  }
}
.userAccount__name {
  p {
    margin: 0;
    font-weight: 500;
    color: #000;
    font-size: 1.2rem;
  }
}
.panelWrap {
  span {
    display: inline-block;
    vertical-align: middle;
  }
}
.userAccount__name {
  margin-top: 25px;
}
/*##### Arabic layout Styles#####*/
.ar_layout {
  .mobile--active .closeNav {
    left: -35px;
    right: auto;
    text-align: left;
  }
  .siteNavMobile {
    transform: translateX(240px);
    right: 0;
    left: auto;
  }
  .mobile--active .siteNavMobile {
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  .subNavLinks {
    .icon {
      direction: rtl;
    }
  }
  .navigation__notificationWrap {
    right: auto;
    left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/prizeo/Navigation.vue